export const APP_NAME = 'EMVAL';
export const APP_NAME_LOWER = 'emval';
export const APP_TAGLINE = 'Akıllı Bütçe Yönetimi';
export const APP_PAGE_TITLE = `${APP_NAME} - ${APP_TAGLINE}`;
